<template> 
    <div>
        <div class="all">
            <!-- DESKTOP -->
            <!-- phrase d'accroche centrer et en violet -->
           <p class="Philosophie is-hidden-touch" style=" color: #482A5C; font-family: 'Spartan', sans-serif; font-weight:bold;">Volonté d’harmoniser les acteurs, les outils et les processus. </p>
            <!-- colonnes-->
            <div class="columns">
                <!-- colonne de gauche contenant l'image-->
                <div class="column is-two-fifths-desktop is-hidden-touch" >
                     <img class ="img " style=" width:50% ;height:auto ; float:right; " src="../../public/assets/img/nous.png" />
                </div>
                <!-- colonne de droite contenant le texte -->
                <div class="column is-three-fifths is-hidden-touch ">
                    <!-- colonne de gauche : titre -->
                    <p class="Titre " style="margin-top:12%;  margin-left:13%;"> QUI SOMMES NOUS ?</p>
                    <!-- colonne de gauche : description -->
                    <p class="description" style=" float: left; margin-right:33%; margin-left:13%;"> 
                        Basée à Nantes depuis 2012, FOBware SI est un cabinet de conseils en systèmes d’information à taille humaine.<br><br>
                        Notre expérience, nos collaborateurs, et leurs compétences contribuent à entretenir et développer le niveau de qualité de nos prestations.<br><br>
                        Notre approche pragmatique, et notre exigence de satisfaction client nous permettent d’accompagner nos partenaires dans la vie de leurs systèmes d’information (projets, maintenance, ...).
                    </p>   
                </div>
            </div> 

        </div>
             <!-- MOBILE - TABLET -->
        <div class="all">
            <!-- phrase d'accroche centrer et en violet -->
            <p class="Philosophie is-hidden-desktop is-size-5" style="margin-top:30%;">Volonté d’harmoniser les acteurs, les outils et les processus. </p>
            <!-- cImage centrer -->
            <img class ="img is-hidden-desktop" style=" width:50% ;height:auto;  display: block;margin-left: auto; margin-right: auto " src="../../public/assets/img/nous.png" />
            <!-- titre -->
            <p class="Titre is-hidden-desktop" style="margin-top:12%;  font-size:3vh; text-align:center;"> QUI SOMMES NOUS ?</p>
            <!--  description -->
            <p class="description is-hidden-desktop is-size-6" style=" margin-top:8%; margin-right:8%; margin-left:8%; "> 
                        Basée à Nantes depuis 2012, FOBware SI est un cabinet de conseils en systèmes d’information à taille humaine.<br>p
                        Notre expérience, nos collaborateurs, et leurs compétences contribuent à entretenir et développer le niveau de qualité de nos prestations.<br><br>
                        Notre approche pragmatique, et notre exigence de satisfaction client nous permettent d’accompagner nos partenaires dans la vie de leurs systèmes d’information (projets, maintenance, ...).
            </p>    
        </div>
    
    </div>    
</template>

<script>


export default {
  name: "AboutPage",
   components: {
      
  },
};
</script>
<style scoped> 
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');
  
  


 #all{
     margin-top:8%;
     width:100%;
 } 
.Philosophie{
    margin-top:8%;
    color: #482A5C; 
    font-family: 'Spartan', sans-serif; 
    font-weight:bold;
    font-size:2.5vh;
} 

.Titre{
 text-align: justify;
 font-family: 'Montserrat', sans-serif;
 font-weight: bold;
 font-size:4vh;

}

.description{
 text-align: justify;
 margin-top:4%; 
 font-size:2.5vh;
 font-family: 'Lato', sans-serif;

}

.img{
 margin-top:17%;
}
</style>